"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const excavator_types_1 = require("./excavator.types");
const app_types_1 = require("pages/app.types");
const initialState = {
    isLoading: true,
    isLoadingDetail: true,
    isLoadingSubmit: false,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    mutationMode: false,
    dataContractor: [],
    total: 0,
    dataItem: {
        id: '',
        contractor_id: '',
        contractor_name: '',
        contractor: {
            id: '',
            contractor_code: '',
            contractor_name: '',
            contractor_type: '',
            is_active: {
                status: 'Active',
                value: true
            },
            modified_by: '',
            modified_date: new Date(),
            created_by: '',
            created_date: new Date(),
        },
        excavator_no: '',
        excavator_capacity: 0,
        excavator_spec: '',
        is_active: {
            value: true,
            status: 'Active'
        },
        modified_by: '',
        created_date: new Date(),
        modified_date: new Date()
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const excavatorReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [excavator_types_1.excavatorTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [excavator_types_1.excavatorTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [excavator_types_1.excavatorTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError,
            errorCode,
            errorMessage, isLoading: false, isSuccess: false, isLoadingSubmit: false });
    },
    [excavator_types_1.excavatorTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingSubmit } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingSubmit, mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [excavator_types_1.excavatorTypes.ON_DELETE]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, mutationMode: false });
    },
    [excavator_types_1.excavatorTypes.GET_DETAIL]: (state, action) => {
        const dataContractor = action.payload;
        return Object.assign(Object.assign({}, state), { dataContractor, isLoadingDetail: false });
    },
    [excavator_types_1.excavatorTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { dataItem,
            isSuccess, isLoadingSubmit: isSuccess, mutationMode: false, isLoading: true, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [excavator_types_1.excavatorTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [excavator_types_1.excavatorTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    }
});
exports.default = excavatorReducer;
